import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Wraps a collection-tabs section configured to show recently viewed products.
 * On connect, re-renders the section against the storefront search endpoint,
 * filtered to the customer's recently viewed product IDs, then reveals it.
 * Stays hidden if the customer hasn't viewed any other products yet.
 */
class RecentlyViewedTabs extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  async #render() {
    const sectionId = this.dataset.sectionId;
    const currentProductId = this.dataset.currentProductId;
    if (!sectionId) return;

    const viewedProducts = RecentlyViewed.getProducts().filter((id) => id !== currentProductId);

    if (viewedProducts.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedProducts.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    await sectionRenderer.renderSection(sectionId, { url, cache: false });
    this.hidden = false;
  }
}

if (!customElements.get('recently-viewed-tabs')) {
  customElements.define('recently-viewed-tabs', RecentlyViewedTabs);
}
